import { useEffect } from '../../../src/InBuildImports';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Properties, systemConfiguration, includeScripts, includeBootstrapCss, includeBundleBootstrapCss } from '../../../src/CommonImports';
import './../css/GRecentJobs.css';
import './../css/GSideBar.css';
import './../css/Gtop.css';
import './../css/GFooter.css';
import './../css/GPage2.css';
import './../css/GPage3.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function GJobMap() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';

    useEffect(() => {
        includeBootstrapCss();
        includeBundleBootstrapCss();
        includeScripts();
        document.addEventListener("DOMContentLoaded", function () {
            if (window.innerWidth >= 992) {
                const sidebar = Offcanvas(document.getElementById(Properties.SIDEBAR_MENU_PROP));
                sidebar.show();
            }
        });
    }, []);


    return (
        <div>
            <section className="mb-5">

                <div className="custom-map-wrapper">
                    <div className="ratio ratio-16x9 border rounded shadow">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m26!1m12!1m3!1d7564.883011547661!2d73.75212674207604!3d18.554123730183623!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m11!3e6!4m3!3m2!1d18.556518399999998!2d73.75749119999999!4m5!1s0x683cffc5969fd7f7%3A0x346fb6af1e29164d!2sGrastech3%20IT%20Solutions%20Pvt.%20Ltd.%2C%20Hare%20Krishna%20Heights%2C%20Vidya%20valley%20road%2C%20Pashan%20-%20Sus%20Rd%2C%20Pune%2C%20Maharashtra%20411021!3m2!1d18.5517292!2d73.7527944!5e0!3m2!1sen!2sin!4v1746013216825!5m2!1sen!2sin"
                            allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>



                <div className="text-center mb-4">
                    <h2
                        className="fw-bold mx-auto mt-3 mb-4"
                        style={{ maxWidth: '800px', fontSize: '2.2rem', fontWeight: 800, lineHeight: 1.4 }}
                    >
                        You are always welcome to<br />
                        <span>visit our little studio</span>
                    </h2>
                </div>



                <div className="row text-start mb-5" style={{ marginTop: '80px' }}>

                    <div className="col-md-4 mb-4">
                        <h5 className="mb-3">Office</h5>
                        <p className="mb-1">Grastech3 IT Solutions Pvt Ltd.</p>
                        <p className="mb-1">1st floor, Hare Krishna Heights,</p>
                        <p className="mb-1">Vidya valley road, Sus Gaon</p>
                        <p className="mb-1">Pune - 411021</p>
                        <p className="mb-1"><strong>Phone:</strong>  +91 8452041545</p>
                        <p className="mb-1"><strong>Email:</strong> info@grastech3solutions.com</p>
                        <a href="#" className="btn btn-outline-primary btn-sm mt-3">View map</a>
                    </div>
                    <div className="col-md-4 mb-4">
                        <h5 className="mb-3">Studio</h5>
                        <p className="mb-1">Grastech3 IT Solutions Pvt Ltd.</p>
                        <p className="mb-1">1st floor, Hare Krishna Heights,</p>
                        <p className="mb-1">Vidya valley road, Sus Gaon</p>
                        <p className="mb-1">Pune - 411021</p>
                        <p className="mb-1"><strong>Phone:</strong>  +91 8452041545</p>
                        <p className="mb-1"><strong>Email:</strong> info@grastech3solutions.com</p>
                        <a href="#" className="btn btn-outline-primary btn-sm mt-3">View map</a>
                    </div>
                    <div className="col-md-4 mb-4">
                        <h5 className="mb-3">Shop</h5>
                        <p className="mb-1">Grastech3 IT Solutions Pvt Ltd.</p>
                        <p className="mb-1">1st floor, Hare Krishna Heights,</p>
                        <p className="mb-1">Vidya valley road, Sus Gaon</p>
                        <p className="mb-1">Pune - 411021</p>
                        <p className="mb-1"><strong>Phone:</strong>  +91 8452041545</p>
                        <p className="mb-1"><strong>Email:</strong> info@grastech3solutions.com</p>
                        <a href="#" className="btn btn-outline-primary btn-sm mt-3">View map</a>
                    </div>
                </div>


                <div className="text-center mb-7">
                    <h5 className="text-primary fw-semibold">Send Message</h5>
                    <h2 className="fw-bold mb-3">Drop Us a Line</h2>
                    <p className="text-muted mb-8">Your email address will not be published. Required fields are marked *</p>
                </div>


                <div className="row text-center mb-5">
                    <div className="col-md-4 mb-6">
                        <img src={`${mediaUrl}headset-color.svg?${sasToken}`} alt="Phone" className="mb-3" style={{ height: '40px' }} />
                        <p className="text-muted small mb-1">Phone</p>
                        <p className="fw-semibold mb-0">+91-8452041545</p>
                        <p className="fw-semibold">+91-9284735629</p>
                    </div>
                    <div className="col-md-4 mb-6">
                        <img src={`${mediaUrl}plane-color.svg?${sasToken}`} alt="Email" className="mb-3" style={{ height: '40px' }} />
                        <p className="text-muted small mb-1">Email</p>
                        <p className="fw-semibold mb-0">info@grastech3solutions.com</p>
                        {/* <p className="fw-semibold">sales@jobhub.com</p>  */}
                    </div>
                    <div className="col-md-4 mb-6">
                        <img src={`${mediaUrl}marker-color.svg?${sasToken}`} alt="Address" className="mb-3" style={{ height: '40px' }} />
                        <p className="text-muted small mb-1">Address</p>
                        <p className="fw-semibold mb-0">Grastech3 IT Solutions Pvt Ltd.</p>
                        <p className="fw-semibold mb-0">1st floor, Hare Krishna Heights,</p>
                        <p className="fw-semibold">Vidya valley road, Sus Gaon Pune -411021</p>
                    </div>
                </div>



                <div className="row justify-content-center">
                    <div className="col-xl-9">
                        <form action="#" method="post" className="p-4 p-md-5 bg-light rounded-4 shadow-sm border border-1">
                            <div className="row g-4">
                                <div className="col-md-6">
                                    <input type="text" name="name" className="form-control rounded-3" placeholder="First Name *" required />
                                </div>
                                <div className="col-md-6">
                                    <input type="email" name="email" className="form-control rounded-3" placeholder="Your Email *" required />
                                </div>
                                <div className="col-md-6">
                                    <input type="tel" name="telephone" className="form-control rounded-3" placeholder="Your Phone" />
                                </div>
                                <div className="col-md-6">
                                    <input type="text" name="subject" className="form-control rounded-3" placeholder="Subject" />
                                </div>
                                <div className="col-12">
                                    <textarea name="message" rows="5" className="form-control rounded-3" placeholder="Message *"
                                        required></textarea>
                                </div>
                                <div className="col-12 text-center">
                                    <button type="submit" className="btn btn-primary px-5 py-2 mt-3 rounded-pill">Send Message</button>
                                </div>
                            </div>
                        </form>
                        <p className="form-message text-center mt-4"></p>
                    </div>
                </div>

            </section>
        </div>
    );
}
export default GJobMap;